import { render, staticRenderFns } from "./5.vue?vue&type=template&id=4faeea12&scoped=true"
var script = {}
import style0 from "./5.vue?vue&type=style&index=0&id=4faeea12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faeea12",
  null
  
)

export default component.exports